import { useCallback } from 'react';

import { XIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { Button } from '@/components/ui/button';
import { iconByType } from '@/redux/dialogs/helper';
import { clearSelection } from '@/redux/nodes/actions';
import { preventClickThrough } from '@/util/util';

import styles from './ToolkitWrapper.module.scss';

const ToolkitWrapper = ({ type, children }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const onCloseClick = useCallback(
    (e) => {
      preventClickThrough(e);
      dispatch(clearSelection());
    },
    [dispatch]
  );
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.icon}>
          {iconByType({ id: type, size: 28, color: 'var(--foreground)' })}
        </div>
        <span className="text-sm leading-5 font-semibold">{t(`actions.types.${type}`)}</span>
        <span className={styles.close}>
          <Button
            variant="ghost-neutral"
            size="icon-sm"
            aria-label={t('common.collapse')}
            onClick={onCloseClick}
          >
            <XIcon size={16} />
          </Button>
        </span>
      </div>
      <div className={styles.children}>{children}</div>
    </div>
  );
};
export default ToolkitWrapper;
